module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// /home/readymade/apps/facelift_production/shared/~/@stimulus/polyfills/~/core-js/modules/_is-object.js
// module id = 38
// module chunks = 0